export default __webpack_public_path__ + "static/original-co-2e103c4d7064bb6045887ff9f08664a5.jpg";